import React from 'react'

export default function Header() {
  return (
    <div className="header">&nbsp;Mitram - The friend we all need. </div>
  )
}
